import React from "react";

export const IMPLEMENTATION_TYPE_RESULT = {
    VALID: 1,
    INVALID: 2,
    IRRELEVANT: 3,
}

export const IMPLEMENTATION_TYPE_PRODUCTS = {
    ACS: 1,
    "3DS": 2
}

export const GETTING_STARTED_DEFAULT_ANSWER = () => ({ 1: 1, 2: 1, 3: 1, 4: 5 })

export const IMPLEMENTATION_REQUIREMENTS = {
    EMVCO_TESTING_LOA: 1,
    PCI_3DS_AOC: 2,
    PCI_3DS_CORE_AOC: 3,
    VISA_ACS_LOA: 4,
    VISA_TPA: 5,
    VISA_SECURE_PRODUCT_PROVIDER: 6,
    BID: 7,
    VSTS_TESTING_FEES: 8,
    COMPLETE_VSTS_TESTING: 9
}

export const TABLE_HEADERS_ACS = [
    {
        item: "EMVCo Testing and LOA",
        remark: <></>,
        footnote: ""
    },
    {
        item: "PCI 3DS-Core AOC",
        remark: <></>,
        footnote: ""

    },
    {
        item: "Visa ACS Security Program",
        remark: <></>,
        footnote: ""
    },
    {
        item: "Visa Secure Product Provider Agreement",
        remark: <></>,
        footnote: ""
    },
    {
        item: "Have a Visa Business ID (BID)",
        remark: <></>,
        footnote: ""
    },
    {
        item: "Pay VSTS Testing Fee(s)",
        remark: <></>,
        footnote: ""
    },
    {
        item: "Complete VSTS Testing",
        remark: <></>,
        footnote: ""
    },
]

export const TABLE_HEADERS_3DS = [
    {
        item: "EMVCo Testing and LOA",
        remark: <></>,
        footnote: "",
    },
    {
        item: "PCI 3DS AOC",
        remark: <></>,
        footnote: "",
    },
    {
        item: "Visa Third-Party Agent Program (TPA)",
        remark: <></>,
        footnote: "",
    },
    {
        item: "Visa Secure Product Provider Agreement",
        remark: <></>,
        footnote: "",
    },
    {
        item: "Have a Visa Business ID (BID)",
        remark: <></>,
        footnote: "",
    },
    {
        item: "Pay VSTS Testing Fee(s)",
        remark: <></>,
        footnote: "",
    },
    {
        item: "Complete VSTS Testing",
        remark: <></>,
        footnote: "",
    },
]

export const QUESTIONS_ANSWERS_ACS = [
    {
        question: "Are you BUILDING or BUYING ACS?",
        answers: [
            { label: `I am building my ACS`, value: 1 },
            { label: `I am buying my ACS`, value: 2 },
        ],
    },
    {
        question: "Are you an ACS Hosting Provider?",
        answers: [
            { label: `I am an ACS Hosting Provider`, value: 1 },
            { label: `I use ACS Hosting Provider services`, value: 3 },
            { label: `I am not an ACS Hosting Provider (and do not use one)`, value: 2 },
        ],
    },
    {
        question: "Do you sell your ACS software to others?",
        answers: [
            { label: `I sell my ACS software to others`, value: 1 },
            { label: `I do not sell my ACS software to others`, value: 2 },
        ],
    },
    {
        question: "Are you a ...(Choose One)?",
        answers:
            [
                { label: `Issuer`, value: 1 },
                { label: `Issuer Processor`, value: 2 },
                { label: `Issuer & Issuer Processor`, value: 3 },
                { label: `I only sell ACS Software`, value: 4 },
                { label: `None of these`, value: 5 },
            ]
    }
]

export const QUESTIONS_ANSWERS_3DS = [
    {
        question: "Are you BUILDING or BUYING 3DS Software?",
        answers: [
            { label: `I am building my EMV 3DS Software`, value: 1 },
            { label: `I am buying my EMV 3DS Software`, value: 2 },
        ],
    },
    {
        question: "Are you a 3DS Server Hosting Provider?",
        answers: [
            { label: `I am a 3DS Server Hosting Provider`, value: 1 },
            { label: `I use 3DS Server Hosting Provider services`, value: 3 },
            { label: `I am not a 3DS Server Hosting Provider (and do not use one)`, value: 2 },
        ],
    },
    {
        question: "Do you sell your 3DS Server software to others?",
        answers: [
            { label: `I sell my 3DS Server software to others`, value: 1 },
            { label: `I do not sell my 3DS Server software to others`, value: 2 },
        ],
    },
    {
        question: "Are you a ...(Choose One)?",
        answers:
            [
                { label: `Acquirer`, value: 6 },
                { label: `Acquirer Processor`, value: 7 },
                { label: `Acquirer & Acquirer Processor`, value: 8 },
                { label: `Merchant`, value: 9 },
                { label: `I only sell 3DS Server Software`, value: 4 },
                { label: `None of these`, value: 5 },
            ]
    }
]

export const GETTING_STARTED_FOOTNOTE_ID = {
    DEFAULT: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    EIGHT: 8,
    NINE: 9,
};

export const GETTING_STARTED_FOOTNOTES = {
    0: {
        label: "",
        links: []
    },
    1: {
        label: "Obtain EMVCo certification for your ACS solution.",
        links: [
            {
                label: "Get EMVCo Certified",
                link: "http://emvco.com/processes/emv-3-d-secure-approval-processes/"
            }
        ]
    },
    2: {
        label: "Ensure your purchased ACS solution is both EMVCo and Visa Secure certified. Obtain the Approval Letters and Reference Numbers.",
        links: [
            {
                label: "Visa's EMV 3DS Approved Products",
                link: "https://www.visasecureservices.com/ApprovedProducts"
            },
            {
                label: "EMVCo EMV 3DS Compliant Products",
                link: "https://www.emvco.com/approved-products/"
            }
        ]
    },
    3: {
        label: "Obtain EMVCo certification for your 3DS Server solution.",
        links: [
            {
                label: "Get EMVCo Certified",
                link: "http://emvco.com/processes/emv-3-d-secure-approval-processes/"
            }
        ]
    },
    4: {
        label: "Ensure your purchased 3DS Server solution is both EMVCo and Visa Secure certified. Obtain the Approval Letters and Reference Numbers.",
        links: [
            {
                label: "Visa's EMV 3DS Approved Products",
                link: "https://www.visasecureservices.com/ApprovedProducts"
            },
            {
                label: "EMVCo EMV 3DS Compliant Products",
                link: "https://www.emvco.com/approved-products/"
            }
        ]
    },
    5: {
        label: "Please upload proof of participation in Visa’s ACS Security Program. This can be in the format of an official Attestation of Compliance signed by Visa or a screenshot of your company’s entry on The Visa Global Registry of Service Providers (be sure to include the company name and Registry Last Update date)",
        links: [
            {
                label: "The Visa Global Registry of Service Providers",
                link: "https://www.visa.com/splisting/searchGrsp.do",
                inline: true
            }
        ]
    },
    6: {
        label: "Please upload proof of participation in Visa’s Third-Party Agent Program. This can be in the format of an official Attestation of Compliance signed by Visa or a screenshot of your company’s entry on The Visa Global Registry of Service Providers (be sure to include the company name and Registry Last Update date)",
        links: [
            {
                label: "The Visa Global Registry of Service Providers",
                link: "https://www.visa.com/splisting/searchGrsp.do",
                inline: true
            }
        ]
    },
    7: {
        label: "Merchants operating 3DS Server software are required to provide PCI DSS compliance validation during the certification process.",
        links: [
            {
                label: "PCI DSS Security Standards",
                link: "https://www.pcisecuritystandards.org/document_library/"
            }
        ]
    },
    8: {
        label: "All EMV 3DS software must be tested and certified with Visa prior to connecting to the Visa Secure Directory Server.",
        links: []
    },
    9: {
        label: "Merchants who wish to connect 3DS Server software to the Visa Secure Directory Server must have a Visa Business ID (BID). Contact your Visa representative for assistance.",
        links: []
    },
};

export const PACKAGE_TYPE = {
    NEW: 1,
    REOPEN: 2
}

export const PACKAGE_STATE_TEXT = {
    1: "Draft",
    2: "Pending",
    3: "Returned",
    4: "Reviewed (Deferred)",
    5: "Testing (Deferred)",
    6: "Reviewed",
    7: "Testing",
    8: "Canceled",
    9: "Rejected",
    10: "Completed"

}

export const EMVCO_REGEX_EXPRESSION = {
    ACS: /^3DS_LOA_ACS_\w{4}[\w_]*$/,
    "3DS": /^3DS_LOA_SER_\w{4}[\w_]*$/
}

export const PACKAGE_LIST_INTERNAL_MENU_ITEMS = {
    EXTEND_SUBSCRIPTION: 1,
    DEACTIVATE_ACCESS: 2,
    REACTIVATE_ACCESS: 3
}

export const MS_DYNAMICS_CASES_REGEX = /^\d{10}$/;